export type InviteInfo = {
  invite_code: string | null;
};

type InviteInfoReturnType = {
  invite: InviteInfo;
};

export const Invite: () => InviteInfoReturnType = () => {
  // 检查是否在客户端环境
  const isBrowser = typeof window !== 'undefined';

  // 如果不是浏览器环境，返回空的UTM对象
  if (!isBrowser) {
    return { invite: { invite_code: null } };
  }

  const searchParams = new URLSearchParams(window.location.search);
  let newInviteCode = {
    invite_code: searchParams.get('invite_code') || null,
  };
  const urlHasValue = Object.values(newInviteCode).some((k) => k);
  if (urlHasValue) {
    localStorage.setItem('invite', JSON.stringify(newInviteCode));
  } else {
    const storedInviteCode = localStorage.getItem('invite');
    const parsedInviteCode = storedInviteCode
      ? JSON.parse(storedInviteCode)
      : null;
    parsedInviteCode && (newInviteCode = parsedInviteCode);
  }

  return { invite: newInviteCode };
};

export const getInviteInfo = () => Invite();
